'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'telescope';
var width = 576;
var height = 512;
var aliases = [128301];
var unicode = 'e03e';
var svgPathData = 'M459.9 231.7l61.5-35.5-80-138.6-61.5 35.5 80 138.6zM328.5 99.6c-6.2-14.6-.6-31.9 13.5-40.1L431.3 8C446.6-.8 466.2 4.4 475 19.7L571 186c8.8 15.3 3.6 34.9-11.7 43.7l-89.2 51.5c-15.3 8.8-34.9 3.6-43.7-11.7l-.5-.8-42.6 23.1c.6 4 .9 8.1 .9 12.3 0 20.1-7.4 38.5-19.7 52.5l49.9 122.4c5 12.3-.9 26.3-13.2 31.3s-26.3-.9-31.3-13.2L323 381.8c-6 1.5-12.3 2.2-18.8 2.2s-12.8-.8-18.8-2.2l-47 115.3c-5 12.3-19 18.2-31.3 13.2s-18.2-19-13.2-31.3l44.3-108.8-88.6 47.9c-15.2 8.2-34.3 2.9-42.9-12.1l-.7-1.3-44.1 25.5c-11.5 6.6-26.2 2.7-32.8-8.8L3.2 376.4c-6.6-11.5-2.7-26.2 8.8-32.8l44.1-25.5-3.9-6.8c-8.6-14.8-3.9-33.8 10.6-43L328.5 99.6zm73.3 127.5l-49.5-85.7-250.9 159.3 39.1 67.7 85.7-46.3c-1.3-5.8-2-11.9-2-18.1 0-44.2 35.8-80 80-80 22.7 0 43.2 9.5 57.8 24.7l39.9-21.6zM304.2 336a32 32 0 1 0 0-64 32 32 0 1 0 0 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTelescope = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;